import React, {type ReactElement} from "react";
import {useStaticQuery, graphql} from "gatsby";
import {MaybeType} from "/src/types";
import {CTA} from "../../buttons/cta-button/CTAButton";
import {ImageObject} from "../../image/Image";
import HomePageHero from "./HomePageHero";

interface HomePageHeroWrapperProps {
  titleWithLineBreaks: MaybeType<string>;
  ctas: MaybeType<Array<CTA>>;
  copy: MaybeType<string>;
}

const HomePageHeroWrapper = (props: HomePageHeroWrapperProps): ReactElement => {
  const {titleWithLineBreaks, ctas, copy} = props;

  const data = useStaticQuery(
    graphql`
      query ContentfulHomepageAssetsQuery {
        heroSKU: allContentfulAsset(
          filter: {contentful_id: {eq: "yXspbjl9vHXCoFCH61TDx"}}
          limit: 1
        ) {
          edges {
            node {
              file {
                url
              }
              title
            }
          }
        }
        heroMap: allContentfulAsset(
          filter: {contentful_id: {eq: "3Y6JRKhdZ1jtuVLvAufpiu"}}
          limit: 1
        ) {
          edges {
            node {
              file {
                url
              }
              title
            }
          }
        }
        heroExceptions: allContentfulAsset(
          filter: {contentful_id: {eq: "VIRZS6CQlxzlgtJmjIprY"}}
          limit: 1
        ) {
          edges {
            node {
              file {
                url
              }
              title
            }
          }
        }
        messageIcon: allContentfulAsset(
          filter: {contentful_id: {eq: "2JOQoosRbJuxKYczseoMtC"}}
          limit: 1
        ) {
          edges {
            node {
              ...AssetFragment
              gatsbyImageData
            }
          }
        }
        searchIcon: allContentfulAsset(
          filter: {contentful_id: {eq: "6eySjSMxjr0eWCes9cs3HH"}}
          limit: 1
        ) {
          edges {
            node {
              ...AssetFragment
              gatsbyImageData
            }
          }
        }
        profilePhoto: allContentfulAsset(
          filter: {contentful_id: {eq: "3oXTRVYuVruHPEc1yTXBHD"}}
          limit: 1
        ) {
          edges {
            node {
              ...AssetFragment
              gatsbyImageData
            }
          }
        }
        homepageHeroBackground: allContentfulAsset(
          filter: {contentful_id: {eq: "2eC8lb2Et7XpL0NqOGND6g"}}
          limit: 1
        ) {
          edges {
            node {
              ...AssetFragment
              gatsbyImageData
            }
          }
        }
        informationBellIcon: allContentfulAsset(
          filter: {contentful_id: {eq: "6MvRifR8fzZj9wJYGt2BQn"}}
          limit: 1
        ) {
          edges {
            node {
              ...AssetFragment
              gatsbyImageData
            }
          }
        }
      }
    `
  );

  const skusAnimation: string = data.heroSKU.edges[0].node.file?.url!;
  const exceptionsAnimation: string =
    data.heroExceptions.edges[0].node.file?.url!;
  const mapAnimation: string = data.heroMap.edges[0].node.file?.url!;
  const messageIcon: ImageObject = data.messageIcon.edges[0].node;
  const searchIcon: ImageObject = data.searchIcon.edges[0].node;
  const profilePhoto: ImageObject = data.profilePhoto.edges[0].node;
  const informationBellIcon: ImageObject =
    data.informationBellIcon.edges[0].node;
  const homepageHeroBackground: ImageObject =
    data.homepageHeroBackground.edges[0].node;

  return (
    <HomePageHero
      titleWithLineBreaks={titleWithLineBreaks}
      ctas={ctas}
      copy={copy}
      skusAnimation={skusAnimation}
      exceptionsAnimation={exceptionsAnimation}
      mapAnimation={mapAnimation}
      messageIcon={messageIcon}
      searchIcon={searchIcon}
      profilePhoto={profilePhoto}
      informationBellIcon={informationBellIcon}
      homepageHeroBackground={homepageHeroBackground}
    />
  );
};

export default HomePageHeroWrapper;
